import { RecoilRoot } from 'recoil';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { Noto_Sans_KR } from '@next/font/google';
import type { AppProps } from 'next/app';
import '/src/styles/globals.css';
import Layout from '../components/common/Layout';
import ErrorBoundary from '../components/common/ErrorBoundary';

const notoSans = Noto_Sans_KR({
  weight: ['300', '400', '500', '700'],
  subsets: ['latin'],
  style: 'normal',
});

function MyApp({ Component, pageProps }: AppProps): JSX.Element {
  const client: QueryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: true, // 윈도우를 나갔다 다시 들어왔을 때 refetch 되는지 여부
        refetchOnMount: false, // 마운트 마다 refetch 여부
        retry: false, // 재시도 여부
        staleTime: 1000 * 60 * 5, // fresh에서 stale이 되기까지의 시간 => 5분 (1000m/s * 60 * 5);
      },
    },
  });

  return (
    <RecoilRoot>
      <QueryClientProvider client={client}>
        <ErrorBoundary>
          <style jsx global>
            {`
              * {
                font-family: ${notoSans.style.fontFamily};
              }
            `}
          </style>
          <Layout>
            <Component {...pageProps} />
          </Layout>
        </ErrorBoundary>
        <ReactQueryDevtools />
      </QueryClientProvider>
    </RecoilRoot>
  );
}

export default MyApp;
